import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Pathless module layout for pharmacy, mirroring `apps/api/src/routes/pharmacy`. */
export const Route = createFileRoute("/_authenticated/_pharmacy")({
  component: Outlet,
});
